import React, { useEffect } from 'react';

const TermsOfService: React.FC = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="min-h-screen bg-slate-50 text-slate-900 font-serif">
            {/* Header / Navigation Bar */}
            <header className="bg-white/80 backdrop-blur-md border-b border-slate-200 sticky top-0 z-50">
                <div className="max-w-5xl mx-auto px-6 h-20 flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <img src="/supervisor-logo-2026.png" className="w-10 h-10 rounded-lg shadow-sm" alt="Supervisor Eğitim" />
                        <span className="text-xl font-extrabold text-slate-800 tracking-tight font-sans">Supervisor Eğitim</span>
                    </div>
                    <a href="/" className="text-sm font-semibold text-blue-600 hover:text-blue-700 transition-colors font-sans italic">
                        ← Ana Sayfaya Dön
                    </a>
                </div>
            </header>

            {/* Content Section */}
            <main className="max-w-4xl mx-auto px-6 py-16 md:py-24">
                <div className="bg-white p-8 md:p-16 rounded-[2rem] shadow-2xl shadow-slate-200 border border-slate-100">
                    <div className="text-center mb-16">
                        <h1 className="text-4xl md:text-5xl font-black text-slate-900 mb-6 leading-tight">
                            Kullanım Şartları ve Hizmet Sözleşmesi
                        </h1>
                        <div className="w-24 h-1 bg-gradient-to-r from-indigo-600 to-purple-600 mx-auto rounded-full mb-6"></div>
                        <p className="text-slate-500 font-medium italic">Son Güncelleme: 9 Şubat 2026</p>
                    </div>

                    <div className="space-y-12 text-lg leading-relaxed text-slate-800">
                        <section>
                            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-3">
                                <span className="flex items-center justify-center w-8 h-8 rounded-full bg-slate-100 text-sm font-black">01</span>
                                Akdi İlişkinin Niteliği
                            </h2>
                            <p>
                                İşbu Kullanım Şartları ("Sözleşme"), **Supervisor Eğitim** ("Platform") ile Platform servislerinden istifade eden Gerçek veya Tüzel Kişiler ("Kullanıcı") arasındaki hukuki münasebeti düzenleyen temel belgedir. Platforma erişim sağlanması veya üyelik tesisi, işbu mütalaa edilen şartların ihtirazi kayıt ileri sürülmeksizin kabul edildiği anlamına gelir.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-3">
                                <span className="flex items-center justify-center w-8 h-8 rounded-full bg-slate-100 text-sm font-black">02</span>
                                Hizmet Kapsamı ve Dijital Entegrasyonlar
                            </h2>
                            <p className="mb-4">
                                Platform, yapay zeka destekli eğitim danışmanlığı, rehberlik ve akademik takip hizmetleri sunar. Hizmetin ifası sırasında Kullanıcı'nın rızası dahilinde üçüncü taraf servislerle (özellikle Google Takvim ve Meet) entegrasyon sağlanabilir.
                            </p>
                            <div className="bg-slate-50 p-6 rounded-2xl border border-slate-100 text-sm">
                                <h3 className="font-bold mb-3 text-slate-900 uppercase tracking-wider">Kullanıcı Sorumluluğu:</h3>
                                <p className="opacity-90">
                                    Kullanıcı, entegrasyon sağlanan Google hesaplarının güvenliğinden ve bu hesaplar üzerinden paylaşılan verilerin doğruluğundan bizzat sorumludur. Platform, üçüncü taraf servislerin teknik aksaklıklarından dolayı kusursuz sorumluluk taşımaz.
                                </p>
                            </div>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-3">
                                <span className="flex items-center justify-center w-8 h-8 rounded-full bg-slate-100 text-sm font-black">03</span>
                                Fikri ve Sınai Mülkiyet Hakları
                            </h2>
                            <p>
                                Platform içerisinde yer alan tüm içerikler, algoritmalar, yazılım kodları, logo ve tasarımlar; **5846 sayılı Fikir ve Sanat Eserleri Kanunu** kapsamında koruma altındadır. Söz konusu unsurların kısmen veya tamamen kopyalanması, akademik veya ticari amaçlarla izinsiz iktibas edilmesi hukuki ve cezai müeyyideleri beraberinde getirir.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-3">
                                <span className="flex items-center justify-center w-8 h-8 rounded-full bg-slate-100 text-sm font-black">04</span>
                                Mücbir Sebepler ve Hizmet Kesintisi
                            </h2>
                            <p>
                                Doğal afetler, siber saldırılar, telekomünikasyon altyapı sorunları gibi Platform'un kontrolü dışında gelişen mücbir sebepler (Force Majeure) durumunda; hizmetin geçici olarak askıya alınmasından dolayı Platform'un herhangi bir tazmin yükümlülüğü doğmayacaktır.
                            </p>
                        </section>

                        <section>
                            <h2 className="text-2xl font-bold text-slate-900 mb-4 flex items-center gap-3">
                                <span className="flex items-center justify-center w-8 h-8 rounded-full bg-slate-100 text-sm font-black">05</span>
                                Uyuşmazlıkların Halli ve Yetkili Mahkeme
                            </h2>
                            <p>
                                İşbu Sözleşme'den kaynaklanabilecek her türlü uyuşmazlıkta Türkiye Cumhuriyeti Kanunları uygulanacaktır. Uyuşmazlıkların çözümünde **İstanbul (Çağlayan) Mahkemeleri ve İcra Daireleri** münhasıran yetkilidir.
                            </p>
                        </section>

                        <section className="pt-8 border-t border-slate-100">
                            <p className="text-slate-500 text-sm text-center italic">
                                İşbu metin, taraflar arasındaki irade beyanının dijital ortamdaki teyididir. Üyelik işlemlerine devam edilmesi durumunda, yukarıdaki maddeler yürürlüğe girmiş addolunur.
                            </p>
                        </section>
                    </div>
                </div>
            </main>

            {/* Simple Footer */}
            <footer className="bg-slate-900 text-white py-12 px-6">
                <div className="max-w-5xl mx-auto flex flex-col md:flex-row justify-between items-center gap-8">
                    <p className="text-slate-400 text-sm italic">© 2026 Supervisor Eğitim. Tüm hakları mahfuzdur.</p>
                    <div className="flex gap-8 text-sm font-medium">
                        <a href="/terms" className="text-purple-400">Kullanım Koşulları</a>
                        <a href="/privacy" className="hover:text-purple-400 transition-colors">Gizlilik Politikası</a>
                    </div>
                </div>
            </footer>
        </div>
    );
};

export default TermsOfService;
